import Autosave from 'stimulus-rails-autosave'

export default class extends Autosave {}
